/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllPalReauthSubmissionsResponse } from './FindAllPalReauthSubmissionsResponse';
import {
    FindAllPalReauthSubmissionsResponseFromJSON,
    FindAllPalReauthSubmissionsResponseFromJSONTyped,
    FindAllPalReauthSubmissionsResponseToJSON,
    FindAllPalReauthSubmissionsResponseToJSONTyped,
} from './FindAllPalReauthSubmissionsResponse';

/**
 * 
 * @export
 * @interface FindAllPalReauthSubmissions200Response
 */
export interface FindAllPalReauthSubmissions200Response {
    /**
     * 
     */
    data?: FindAllPalReauthSubmissionsResponse;
}

/**
 * Check if a given object implements the FindAllPalReauthSubmissions200Response interface.
 */
export function instanceOfFindAllPalReauthSubmissions200Response(value: object): value is FindAllPalReauthSubmissions200Response {
    return true;
}

export function FindAllPalReauthSubmissions200ResponseFromJSON(json: any): FindAllPalReauthSubmissions200Response {
    return FindAllPalReauthSubmissions200ResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthSubmissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthSubmissions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllPalReauthSubmissionsResponseFromJSON(json['data']),
    };
}

export function FindAllPalReauthSubmissions200ResponseToJSON(json: any): FindAllPalReauthSubmissions200Response {
    return FindAllPalReauthSubmissions200ResponseToJSONTyped(json, false);
}

export function FindAllPalReauthSubmissions200ResponseToJSONTyped(value?: FindAllPalReauthSubmissions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllPalReauthSubmissionsResponseToJSON(value['data']),
    };
}

